/*
GeoViz's mapbox source/layer ids and feature-state keys. They live apart from
the component so the harness specs can import them under node (GeoViz itself
pulls in mapbox-gl's CSS) — renaming one here reaches the specs automatically.
*/

export const SELECTED_SITE_STATE_KEY = 'selected-site';
export const HOVERED_FEATURE_STATE_KEY = 'hovered-feature';
export const SELECTED_CONTRIBUTING_AREA_STATE_KEY = 'selected-contributing-area';

export const DRAINAGE_SOURCE_ID = 'site-drainage';

export const FORECAST_POINT_SOURCE_ID = 'site-forecast-point';
export const ACTIVE_POINT_LABEL_ID = 'selected-point-label';

export const BASIN_FILL_LAYER_ID = 'basin-area-fill';
export const BASIN_STROKE_DESELECTED_LAYER_ID = 'basin-stroke-deselected';
export const BASIN_STROKE_SELECTED_LAYER_ID = 'basin-stroke-selected';
export const BASIN_POINT_CIRCLE_LAYER_ID = 'basin-forecast-point-circle';

export const CONTRIBUTING_AREA_EDGE_SOURCE_ID = 'contributing-area-edge';
export const CONTRIBUTING_AREA_STROKE_LAYER_ID = 'contributing-area-stroke';
export const CONTRIBUTING_AREA_EDGE_STROKE_LAYER_ID = 'contributing-area-edge-stroke';

export const BASIN_ROUTED_POINT_CIRCLE_LAYER_ID = 'basin-routed-forecast-point-circle';
export const LOCATION_POINT_CIRCLE_LAYER_ID = 'location-forecast-point-circle';
export const GAUGE_POINT_CIRCLE_LAYER_ID = 'gauge-forecast-point-circle';

export const FLOWLINES_SOURCE_ID = 'flowlines';
export const FLOWLINES_LAYER_ID = 'flowlines';
